// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFaceCool = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M8.375 8h7.25C16.385 8 17 8.547 17 9.222c0 .696-.58 1.366-1.181 1.874a2.036 2.036 0 01-2.635.001c-.372-.314-.737-.69-.961-1.097h-.445c-.224.406-.587.782-.959 1.096a2.036 2.036 0 01-2.635.001C7.582 10.59 7 9.92 7 9.222 7 8.547 7.616 8 8.375 8m6.369 5.501C14.246 14.368 13.224 15 12 15c-.566 0-1.09-.136-1.54-.368l-.92 1.776A5.35 5.35 0 0012 17c1.909 0 3.607-.989 4.478-2.501z" />,
    <path fillRule="evenodd" d="M12 21a9 9 0 100-18 9 9 0 000 18m0-2a7 7 0 100-14 7 7 0 000 14" />
  );
export default SvgIconFaceCool;
